import { mGovRedesignBlockClass } from "../constants/cssSelectors";
import { useMctFlags } from "./useMctFlags";

export function useMgovRedesignClass() {
  const { tmpFeEnableMgovReskin } = useMctFlags();
  return tmpFeEnableMgovReskin ? mGovRedesignBlockClass : "";
}
